import { ECardinality, IAction, IConditionModel, ISymbol } from "./builder.dtos";
import { Dictionary } from "./dictionary";
import { IProjectRole } from "./role";
import { BackEndValueType } from "./value-type";

export interface IWorkFlowBaseInfo {
  id: string;
  name: string;
  displayName: string;
  description: string;
  parameters?: IWFParameter[];
  kProject_Id: string;
  inactived?: boolean;
  userInUse?: string;
}

export interface IWorkFlow extends IWorkFlowBaseInfo {
  // #region JSON
  happyPathDefinition?: IHappyPathPhaseModel[];
  nodes?: IWFNodes;
  parameters?: IWFParameter[];
  // #endregion
  xml?: string;
}

// workflow definition (ÇANTA)
export interface IWFParameter {
  id: string;
  name: string;
  dataType: BackEndValueType; /// ///backend'i string tipinde olmalı! Yandakilerden biri gelecek--> "Unknown" | "Boolean" | "Bytea" | "Byte" | "DateTimeOffset" | "Decimal" | "Double" | "Guid" | "Int16" | "Int32" | "Int64" | "Single" | "String" | "Image"
  parameterType: EWFParamType;
  isInput?: boolean;
  isOutput?: boolean;
  isBusinessObject: boolean;
  defaultValue?: ISymbol;
  /** True when the parameter is a complex object / list of objects (references a Kuika Data Type). */
  isObject?: boolean;
  /** ECardinality.Many = list-of-object; otherwise single object. Ignored for scalars. */
  cardinality?: ECardinality;
  /** Referenced Kuika Data Type name (catalog TypeModel.Name) when isObject is true. */
  dataTypeName?: string;
}

export interface IWFStepParameter extends IWFParameter {
  value: ISymbol;
}

export interface IStepParameter {
  id: string;
  value?: ISymbol;
  /** Target field/property name when this is a nested field mapping of a complex output parameter. */
  name?: string;
  /** Per-field mappings when the output parameter is a complex object bound field-by-field. */
  parameters?: IStepParameter[];
}

export interface IInteractionParameter extends IStepParameter {
  isMailParameter?: boolean;
}

export interface IWFNodes {
  description: string;
  dueIn: IWFDue;
  steps: IWFStep[];
  forwards: IWFForward[];
  decisions: IWFDecision[];
  gateways: IWFGateway[];
  events: IWFEvent[];
  lanes: IWFLane[];
}

export interface IHappyPathPhaseModel {
  id: string;
  happyPathPhase: string;
  phaseOrder: number;
}

export interface IWFEvent extends IWFNode {
  eventType: EWFEventType;
  eventTag?: EWFEventTag;
  dueIn?: IWFDue;
}

export interface IWFBoundaryEvent extends IWFEvent {
  isInterrupting: boolean;
  timerEventDue: IWFDue | undefined;
  useStepTimer: boolean;
}

export interface IWFLane extends IWFNode {
  assignment: IWFNodeAssignment;
}

export enum EWFEventType {
  Start = 1,
  End = 2,
  Intermediate = 3,
  Boundary = 4
}

export enum EWFEventTag {
  Undefined = 0,
  Timer = 1,
  Message = 2,
  Signal = 3
}

export interface IWFNode {
  id: string;
  name: string;
  nodeType: EWFNodeType;
}

export enum EWFNodeType {
  Step = 1,
  Gateway = 2,
  Arrow = 3,
  Event = 4,
  Lane = 5
}

export interface IWFGateway extends IWFNode {
  gateWayType: EWFGatewayType;
}

export enum EWFGatewayType {
  Conditional = 1,
  Paralel = 2,
  Inclusive = 3
}

export interface IWFDecision extends IWFArrow {
  condition: IConditionModel;
  internalIndex: number;
  // decisionType: EDecisionType;
  isDefault: boolean;
}

export enum EDecisionType {
  RunFirstTrueConditionInOrder = 1
}

export interface IWFStartEvent extends IWFNode {
  stepType: EWFStepType;
  outputsMap: Dictionary;
  extraParameters: Dictionary;
  assignmentId?: string;
  assignmentType?: EWFAssignmentType;
}

export interface IWFStep extends IWFNode {
  description: string;
  dueIn: IWFDue;
  stepType?: EWFStepType;
  inputsMap?: Dictionary; // DON'T USE THIS! No mapping in frontend
  outputsMap?: Dictionary; // DON'T USE THIS! No mapping in frontend
  parameters: IWFStepParameter[]; // DON'T USE THIS! Only output parameters are used in frontend
  outputParameters: IStepParameter[]; // Input Parameters will be added on backend (Analyzer)
  extraParameters?: Dictionary; // actionId,screenId,sla
  assignment: IWFNodeAssignment;
  useLaneAssignment: boolean;
  notifyUser?: boolean | undefined;
  actions?: IAction[];
  boundaryEvent?: IWFBoundaryEvent;
  addUserInteractionsToMail?: boolean;
  addGoToTaskButtonToMail?: boolean | undefined;
  mailInteractions?: IMailInteraction[];
  userInteractions?: IUserInteraction[];
  selectedAppIdsForNotification?: string[];
  useCustomTemplate?: boolean;
  templateId?: string;
  templateParameters?: ITemplateParameter[];
  subprocess?: IWFNodes;
  linkedProcess?: ILinkedProcessInfo;
}

export interface ILinkedProcessInfo {
  linkedProcessId: string | undefined;
  linkedProcessMappings: ILinkedProcessMappingInfo[];
}

export interface ILinkedProcessMappingInfo {
  linkedProcessOutputParameter: string | undefined;
  callerProcessOutputParameter: string | undefined;
}

export interface IMailInteraction {
  userInteractionId: string;
  id?: string; // obsolete
  label?: string; // obsolete
  parameters?: IWFStepParameter[]; // obsolete
}

export interface IUserInteraction {
  id: string;
  label: string;
  buttonId?: string;
  parameters: IInteractionParameter[];
}

export interface IWFNodeAssignment {
  assignmentType?: EWFAssignmentType;
  assignmentId?: string; // "Everyone" | "None" | "Role" | "Dynamic" //VTO: Obsolete. Don't use with any logic on it
  dynamicAssignmentAction: IAction | undefined;
  dynamicAssignmentActionReturnType?: string | undefined;
  dynamicAssignmentActionField?: ISymbol | undefined;
  roleAssignmentParameter: IProjectRole | undefined;
}

export interface IWFDue {
  dueUnit: EWFDueUnit;
  dueValue: number;
}

export enum EWFStepType {
  ScreenInteraction = 1,
  BackendInteraction = 2,
  Subprocess = 3,
  LinkedProcess = 4
}

export enum EWFDueUnit {
  Minutes = 1,
  Hours = 2,
  Days = 3
}

export enum EWFAssignmentType {
  none = 1,
  role = 2,
  everyone = 3,
  dynamic = 4,
  external = 5
}

export interface IWFArrow extends IWFNode {
  fromNodeId: string;
  toNodeId: string;
  arrowType: EWFArrowType;
}

export enum EWFArrowType {
  Forward = 1,
  Decision = 2
}

export enum EWFParamType {
  Input = 1,
  Output = 2,
  Bag = 3
}

export interface ITemplateParameter {
  name: string;
  value: ISymbol | undefined;
}

export type IWFForward = IWFArrow;
